export async function settleRoutePreloads(
  tasks: Array<Promise<unknown>>,
): Promise<void> {
  if (tasks.length === 0) {
    return;
  }

  await Promise.allSettled(tasks);
}
